import type { IBankingDetails } from '@insio/shared-types';

export function formatAccountNumber(details: IBankingDetails | null | undefined): string {
  if (!details) return '';
  const { bankAccount, bankCode } = details;
  if (!bankAccount) return '';
  return bankCode ? `${bankAccount}/${bankCode}` : bankAccount;
}
